import React from 'react';
import { Switch } from '@headlessui/react';

import PricingFilter from '../../../filterFactory/PriceFilter';
import { useTreatmentFilterStateContext, useTreatmentFilterUpdaterContext } from '../../context/TreatmentFilterContext';
import { useSortAndFilterConfigContext } from '../../../context/SortAndFilterConfigContext';
import { PriceBracket } from '../../../../../../modules/sortAndFilter/config/SortAndFilterConfig';
import useCachedStatistics from '../hooks/useCacheStatistics';

import CheckboxIcon from '../../../../../_ui/_blocks/Form/Inputs/Checkbox/CheckboxIcon/CheckboxIcon';
import FilterSection, { FilterHeadings } from '../FilterUi/FilterSection/FilterSection';
import FilterLabel from '../FilterUi/FilterLabel/FilterLabel';

import styles from './PriceFilter.module.css';

const FILTER_KEY = 'price';

const PriceFilter = () => {
    const { filters } = useTreatmentFilterStateContext();
    const { updateFilters, setLastFilterUpdated } = useTreatmentFilterUpdaterContext();
    const config = useSortAndFilterConfigContext();
    const statistics = useCachedStatistics(FILTER_KEY);

    const priceFilter = filters.get('price') as PricingFilter;

    const priceBrackets = config.filters.price?.brackets || [];

    if (priceBrackets.length === 0) {
        return null;
    }

    return (
        <FilterSection title={FilterHeadings.price} numberSelected={priceFilter.keys.size} className="space-y-100">
            <ul className="space-y-150">
                {priceBrackets.map((priceBracket, index) => {
                    const priceBracketAsString = priceBracket.join('-');
                    const statistic =
                        statistics.find(({ key }) => (key as PriceBracket).join('-') === priceBracketAsString)?.statistics.value || 0;

                    const checked = priceFilter.keys.has(priceBracketAsString);

                    const handleChange = () => {
                        if (checked) {
                            priceFilter.keys.delete(priceBracketAsString);
                        } else {
                            priceFilter.keys.add(priceBracketAsString);
                        }
                        updateFilters();
                        setLastFilterUpdated(FILTER_KEY);
                    };

                    return (
                        <li key={priceBracketAsString} className={!statistic ? 'opacity-50' : ''}>
                            <Switch onChange={handleChange} className={styles.option} checked={checked} title={`option-${index}`}>
                                <FilterLabel>{priceFilter.formatTagLabel(priceBracketAsString)}</FilterLabel>
                                <CheckboxIcon checked={checked} className="flex-shrink-0" />
                            </Switch>
                        </li>
                    );
                })}
            </ul>
        </FilterSection>
    );
};

export default PriceFilter;
